// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/report_assay_info.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CurveType } from "../../../common/types/v1/curve_type_pb";
import { file_quanterix_common_types_v1_curve_type } from "../../../common/types/v1/curve_type_pb";
import type { CurveWeightType } from "../../../common/types/v1/curve_weight_type_pb";
import { file_quanterix_common_types_v1_curve_weight_type } from "../../../common/types/v1/curve_weight_type_pb";
import type { AssayLimits } from "./assay_limits_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_assay_limits } from "./assay_limits_pb";
import type { SampleMetadata } from "./sample_metadata_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_sample_metadata } from "./sample_metadata_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/report_assay_info.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_report_assay_info: GenFile = /*@__PURE__*/
  fileDesc("Cj9xdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvcmVwb3J0X2Fzc2F5X2luZm8ucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSKKBAoOUmVwb3J0UGxleEluZm8SFAoHYW5hbHl0ZRgBIAEoCUgAiAEBEhQKB2JlYWRfaWQYAiABKAlIAYgBARIXCgpsb3RfbnVtYmVyGAMgASgJSAKIAQESPAoJY3VydmVfZml0GAQgASgOMiQucXVhbnRlcml4LmNvbW1vbi50eXBlcy52MS5DdXJ2ZVR5cGVIA4gBARJCCgl3ZWlnaHRpbmcYBSABKA4yKi5xdWFudGVyaXguY29tbW9uLnR5cGVzLnYxLkN1cnZlV2VpZ2h0VHlwZUgEiAEBEhEKBHVuaXQYBiABKAlIBYgBARJICgdzYW1wbGVzGAcgAygLMjcucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLlNhbXBsZU1ldGFkYXRhEk8KDGFzc2F5X2xpbWl0cxgIIAEoCzI0LnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5Bc3NheUxpbWl0c0gGiAEBEhcKCmFzc2F5X25hbWUYCSABKAlIB4gBAUIKCghfYW5hbHl0ZUIKCghfYmVhZF9pZEINCgtfbG90X251bWJlckIMCgpfY3VydmVfZml0QgwKCl93ZWlnaHRpbmdCBwoFX3VuaXRCDwoNX2Fzc2F5X2xpbWl0c0INCgtfYXNzYXlfbmFtZSJgCg9SZXBvcnRBc3NheUluZm8STQoMcGxleF9yZXN1bHRzGAEgAygLMjcucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLlJlcG9ydFBsZXhJbmZvYgZwcm90bzM", [file_quanterix_common_types_v1_curve_type, file_quanterix_common_types_v1_curve_weight_type, file_quanterix_simoa_one_analysis_app_api_v1_assay_limits, file_quanterix_simoa_one_analysis_app_api_v1_sample_metadata]);

/**
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.ReportPlexInfo
 */
export type ReportPlexInfo = Message<"quanterix.simoa_one.analysis_app_api.v1.ReportPlexInfo"> & {
  /**
   * @generated from field: optional string analyte = 1;
   */
  analyte?: string;

  /**
   * @generated from field: optional string bead_id = 2;
   */
  beadId?: string;

  /**
   * @generated from field: optional string lot_number = 3;
   */
  lotNumber?: string;

  /**
   * @generated from field: optional quanterix.common.types.v1.CurveType curve_fit = 4;
   */
  curveFit?: CurveType;

  /**
   * @generated from field: optional quanterix.common.types.v1.CurveWeightType weighting = 5;
   */
  weighting?: CurveWeightType;

  /**
   * @generated from field: optional string unit = 6;
   */
  unit?: string;

  /**
   * @generated from field: repeated quanterix.simoa_one.analysis_app_api.v1.SampleMetadata samples = 7;
   */
  samples: SampleMetadata[];

  /**
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.AssayLimits assay_limits = 8;
   */
  assayLimits?: AssayLimits;

  /**
   * @generated from field: optional string assay_name = 9;
   */
  assayName?: string;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.ReportPlexInfo.
 * Use `create(ReportPlexInfoSchema)` to create a new message.
 */
export const ReportPlexInfoSchema: GenMessage<ReportPlexInfo> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_report_assay_info, 0);

/**
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.ReportAssayInfo
 */
export type ReportAssayInfo = Message<"quanterix.simoa_one.analysis_app_api.v1.ReportAssayInfo"> & {
  /**
   * @generated from field: repeated quanterix.simoa_one.analysis_app_api.v1.ReportPlexInfo plex_results = 1;
   */
  plexResults: ReportPlexInfo[];
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.ReportAssayInfo.
 * Use `create(ReportAssayInfoSchema)` to create a new message.
 */
export const ReportAssayInfoSchema: GenMessage<ReportAssayInfo> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_report_assay_info, 1);

